<template><div><h1>为什么作者直接关闭了我提的 issue</h1>
<p>任何不认真提问题，浪费维护者时间的只有这样处理。</p>
<p>维护者其实没有义务做外包一样回答问题，况且部分问题实在是过于马虎，看了简直是让人生气呐：</p>
<div class="warning">
<p>做为程序员，居然能问出这样的问题？！</p>
</div>
</div></template><script>
export default {
  head: {"title":"为什么作者直接关闭了我提的 issue | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// why-close-my-issue-53.vue?ed74b448